import Checkbox from '@creditflowresearch/uilib/Checkbox';
import { AsyncSelect } from '@creditflowresearch/uilib/Select';
import FilterSection from '@/creditflowresearch/ui/common/components/templates/FilterSection';
import FilterSectionHeader from '@/creditflowresearch/ui/common/components/organisms/FilterSectionHeader';
import useTickerFilter from '@/creditflowresearch/ui/common/hooks/sidebar/useTickerFilter';
import {
  useCorporateBondScreenerSidebarFilterContext,
} from '@/creditflowresearch/application/CorporateBondScreener/Sidebar/useCorporateBondScreenerSidebarFilterContext';
import { FilterSectionIds } from '@/creditflowresearch/ui/components/corporate-bond-screener/Sidebar/Sections/constants';
import { MIN_QUERY_LENGTH } from '@/creditflowresearch/application/BondScreener/constants';

const Ticker = () => {
  const {
    loadOptions,
    selectedOptions,
    handleChange,
    currentOptions,
    isExcluded,
    onToggleExclude,
  } = useTickerFilter(useCorporateBondScreenerSidebarFilterContext);

  return (
    <FilterSection
      sectionId={ FilterSectionIds.Ticker }
      header={ (
        <FilterSectionHeader
          title="TICKER"
          rightSlot={ (
            <Checkbox
              label="Exclude selected"
              checked={ isExcluded }
              onChange={ onToggleExclude }
              dataTest="tickerExcludeCheckbox"
            />
          ) }
        />
      ) }
      dataTest="tickerSection"
    >
      <AsyncSelect
        isMulti
        name="ticker"
        value={ selectedOptions }
        onChange={ handleChange }
        loadOptions={ loadOptions }
        useDebounce={ {
          minInputLength: MIN_QUERY_LENGTH.ticker,
          belowMinLengthMessage: `Search must contain at least ${ MIN_QUERY_LENGTH.ticker } character`,
        } }
        filterOption={ () => true }
        defaultOptions={ currentOptions }
        placeholder="Select Ticker"
        dataTest="tickerSelect"
        noOptionsMessage={ () => 'No results' }
        closeMenuOnSelect={ false }
        hideSelectedOptions={ false }
        isNarrow
      />
    </FilterSection>
  );
};

export default Ticker;
